import moment from 'moment-timezone';

export function parseDate(value) {
    if (!value) {
        return { startDate: null, endDate: null };
    }
    const dates = value.split('-').map((date) => date.trim());
    const startDate = moment.tz(dates[0], 'DD/MM/YYYY', Intl.DateTimeFormat().resolvedOptions().timeZone);
    const endDate = dates[1]
        ? moment.tz(dates[1], 'DD/MM/YYYY', Intl.DateTimeFormat().resolvedOptions().timeZone)
        : null;

    return { startDate, endDate };
}

export function formatDate(startDate, endDate, format = 'DD/MM/YYYY') {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (startDate && endDate) {
        return `${moment.tz(startDate, tz).format(format)}-${moment.tz(endDate, tz).format(format)}`;
    }
    if (startDate && !endDate) {
        return moment.tz(startDate, tz).format(format);
    }
    return '';
}


export function formatFilterData(startDate, endDate, field = 'dateCreated') {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const filterData = [];

    if (startDate && endDate) {
        filterData.push({
            field: field,
            op: '>',
            value: moment.tz(startDate, 'DD/MM/YYYY', tz).startOf('day').utc().toISOString()
        });
        filterData.push({
            field: field,
            op: '<',
            value: moment.tz(endDate, 'DD/MM/YYYY', tz).endOf('day').utc().toISOString()
        });
    } else if (startDate && !endDate) {
        filterData.push({
            field: field,
            op: '>',
            value: moment.tz(startDate, 'DD/MM/YYYY', tz).startOf('day').utc().toISOString()
        });
        filterData.push({
            field: field,
            op: '<',
            value: moment.tz(startDate, 'DD/MM/YYYY', tz).endOf('day').utc().toISOString()
        });
    }
    return filterData;
}

